module.exports = __webpack_public_path__ + "img/1440.dd96d586.jpg";